const defaultState = () => ({
    unacknowledgedAlerts: null,
    notificationInterval: null,
});

const mutations = {
    setUnacknowledged(state, content) {
        state.unacknowledgedAlerts = content.count;
    },
    reset(state) {
        state.unacknowledgedAlerts = null;
    },
    startInterval(state) {
        if (!state.notificationInterval) {
            // initial call
            this.dispatch('getUnacknowledgedAlerts');

            // call every 30 sec
            state.notificationInterval = setInterval(async () => {
                this.dispatch('getUnacknowledgedAlerts');
            }, 30000);
        }
    },
};

const actions = {
    async getUnacknowledgedAlerts({ commit, dispatch }) {
        try {
            const { data } = await this.$rq.getUnacknowledgedAlerts();
            commit('setUnacknowledged', data);
        } catch (err) {
            dispatch('resetAlerts');
        }
    },
    resetAlerts({ commit }) {
        commit('reset');
    },
};

const getters = {
    unacknowledgedAlerts: state => state.unacknowledgedAlerts,
    notificationInterval: state => state.notificationInterval,
};

const state = defaultState();

export default {
    state,
    getters,
    actions,
    mutations,
};
